<template>
    <div v-bind:value="formatedColor" class="wapper">
        <label>{{label}}</label>
        <div class="h-flex">
            <ColorOption v-for="(color,index) in colors" 
            :key="index" 
            :isSelected="index==selectedIndex" 
            :color="color" 
            @selected="select(index)"/>
            <ColorOption  
            :isSelected="selectedIndex == -1" 
            :color="pickerColor.hex8" 
            @selected="select(-1)"
            advanced/>
        </div>
        <Chrome-picker 
            class="picker" 
            v-if="selectedIndex == -1" 
            v-model="pickerColor" />
    </div>
</template>

<script>
import ColorOption from "@/components/ColorOption.vue"
import { Chrome } from 'vue-color'
export default {
    name:"ColorSelector",
    components:{
        ColorOption,
        'Chrome-picker': Chrome,
    },
    props:{
        value:{
            type:String
        },
        colors:{
            type:Array,
            required:true
        },
        label:{
            type:String,
            default:"Label"
        }
    },
    data(){
        return{
            selectedIndex:-1,
            pickerColor:{hex8:"#fff"},
        }
    },
    watch:{
        pickerColor(newVal){
            this.$emit('input',newVal.hex8)
        },
        value(newVal){
            let index = this.colors.indexOf(newVal)
            if (index != -1){
                this.selectedIndex = index
            } else {
                this.pickerColor={hex8:newVal}
            }
        }
    },
    computed:{
        formatedColor(){
            return this.colors[this.selectedIndex]
        }
    },
    methods:{
        select(index){
            this.selectedIndex = this.selectedIndex == index ? -1 : index;
            let color = this.selectedIndex == -1 ? this.pickerColor.hex8:this.formatedColor
            this.$emit('input',color)
        }
    },
    mounted(){
        
    }
}
</script>

<style lang="scss" scoped>
.wapper{
    text-align: left;
    width: 100%;
}
.h-flex{
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
}
.picker{
    margin: auto;
}
</style>